export * from './model-detail-sensor-type-action';
